import { action, makeObservable, observable } from 'mobx'

export class ApiStoreObservables {
  // __ Force reload state observables
  protected refreshBlockedPeriodsCount = 0
  protected refreshBookingsCount = 0

  // __ Loading state observables
  protected forceLoadingOverlay = false
  protected forceBlocksLoadingOverlay = false

  constructor() {
    makeObservable<
      ApiStoreObservables,
      | 'refreshBlockedPeriodsCount'
      | 'refreshBookingsCount'
      | 'forceLoadingOverlay'
      | 'forceBlocksLoadingOverlay'
    >(this, {
      refreshBlockedPeriodsCount: observable,
      refreshBookingsCount: observable,
      forceLoadingOverlay: observable,
      forceBlocksLoadingOverlay: observable,
      triggerLoadingTapesOverlay: action.bound,
      reloadBlockedPeriods: action.bound,
      toggleForceLoadingOverlay: action.bound,
    })
  }

  triggerLoadingTapesOverlay(value: boolean) {
    this.forceLoadingOverlay = value
    this.forceBlocksLoadingOverlay = value
  }

  reloadBlockedPeriods() {
    this.refreshBlockedPeriodsCount += 1
  }

  toggleForceLoadingOverlay = (timeoutTimer: number) => {
    this.triggerLoadingTapesOverlay(true)
    setTimeout(() => this.triggerLoadingTapesOverlay(false), timeoutTimer)
  }
}
